// extracted by mini-css-extract-plugin
export default {"gamesContainer":"HomePage_gamesContainer__bHPdz"};